import { Banner } from '@spotify-internal/encore-web';
import { GraphQLAppError } from '@spotify/confidence-graphql';

import { useDialogContext } from './context';

export const SubmitError = () => {
  const { error } = useDialogContext();
  if (!error) return null;
  const title =
    error instanceof GraphQLAppError
      ? (error.enrichedMessage ?? error.message)
      : error.message;
  return (
    <Banner colorSet="negative" contextual role="alert">
      {title}
    </Banner>
  );
};

SubmitError.displayName = 'DialogComposite.SubmitError';

export default SubmitError;
